import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useIsDesktop, useIsTablet } from "@/hooks";
import { DesktopPreview, MobilePreview, PrintPreview, SliderModal, MasonryModal, } from "@/gallery/components";
import { useGalleryContext } from "@/gallery/contexts";
import { useImages } from "@/gallery/hooks";
import { useFloorplans } from "../Sections/Floorplan";
export const galleryTestId = "cdp-gallery";
export const Gallery = () => {
    // On SSR both previews (mobile AND desktop) are mounted in the DOM
    // On CSR only the relevant preview (mobile OR preview) is mounted in the DOM
    const isTablet = useIsTablet();
    const isDesktop = useIsDesktop();
    const { isSliderModalOpen, openSliderModal, isMasonryModalOpen, openMasonryModal, } = useGalleryContext();
    const { imagesCount } = useImages();
    const { floorplansCount } = useFloorplans();
    const handleOpen = () => {
        if (imagesCount === 0 && floorplansCount > 3) {
            openMasonryModal();
        }
        else if (imagesCount === 0 &&
            floorplansCount > 0 &&
            floorplansCount <= 3) {
            openSliderModal();
        }
        else if (imagesCount > 0 && imagesCount <= 3) {
            openSliderModal();
        }
        else if (imagesCount > 3) {
            openMasonryModal();
        }
    };
    return (_jsx(_Fragment, { children: _jsxs(Box, { as: "section", testId: galleryTestId, marginBottom: {
                "breakpoint.lg": "spacing.32",
            }, position: "relative", unsafe_className: "Gallery", id: "overview", children: [_jsx(PrintPreview, {}), isDesktop && (_jsx(DesktopPreview, { openModal: handleOpen, testId: galleryTestId })), !isSliderModalOpen && isTablet ? (_jsx(MobilePreview, { openModal: handleOpen, testId: galleryTestId })) : null, _jsx(SliderModal, { isOpen: isSliderModalOpen, testId: galleryTestId }), _jsx(MasonryModal, { isOpen: isMasonryModalOpen, testId: `${galleryTestId}.MasonryModal` })] }) }));
};
